export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/9815d1bfc0a3825d13b83f9549afff17.png";